export const isValidIFSC = (data) => {
  if (/^[A-Z]{4}0[A-Z0-9]{6}$/.test(data)) {
    return true;
  } else {
    return false;
  }
};
export const validateForm = (
  requiredFields,
  setErrors,
  formData,
  currentStack, 
  selectedBank,
  selectedBanks
  ) => {
  const newErrors = {};
  requiredFields.forEach((field) => {
    if (
      field !== "bankIFSC" &&
      !formData[field] &&
      field !== "beneficiarySwiftABA"
    ) {
      newErrors[field] =
        `${field.replace(/([A-Z])/g, " $1")} field is required`
          .charAt(0)
          .toUpperCase() +
        `${field.replace(/([A-Z])/g, " $1")} field is required`.slice(1);
    }
    if (
      requiredFields.some((item) => item === "beneficiarySwiftABA") &&
      !formData["beneficiarySwiftABA"]
    ) {
      newErrors["beneficiarySwiftABA"] =
        "Beneficiary SWIFT/ABA field is required";
    }
    if (
      requiredFields.some((item) => item === "bankIFSC") &&
      !formData["bankIFSC"]
    ) {
      if (!formData.bankIFSC) {
        newErrors["bankIFSC"] = "Bank IFSC is required for Indian bank";
      } else if (!isValidIFSC(formData.bankIFSC)) {
        newErrors.bankIFSC = "IFSC Code must be valid";
      }
    }
  });
  if (selectedBank && selectedBanks?.isIndian) {
    if (!formData.bankIFSC) {
      newErrors.bankIFSC = "IFSC Code is required for Indian banks";
    } else if (!isValidIFSC(formData.bankIFSC)) {
      newErrors.bankIFSC = "IFSC Code must be valid";
    }
  }
  // if (
  //   formData.beneficiaryAccountNumber &&
  //   (/[^a-zA-Z0-9]/.test(formData.beneficiaryAccountNumber) ||
  //     /^0+$/.test(formData.beneficiaryAccountNumber))
  // ) {
  //   newErrors.beneficiaryAccountNumber = "No special character allowed.";
  // }
  if (
    (formData.amount !== "" && Number(formData.amount) < 100) ||
    Number(formData.amount) > 1000
  ) {
    newErrors.amount = "Amount must be between $100 and $1000";
  }
  if (formData.ticker !== "" && currentStack?.status === "inactive") {
    newErrors.ticker = "The selected stack is currently inactive.";
  }
  if (formData.featureName && !/^[a-zA-Z0-9 ]+$/.test(formData.featureName)) {
    newErrors.featureName =
      "Feature Name should not contain special character.";
  }

  if (
    formData.componentName &&
    !/^[a-zA-Z0-9 ]+$/.test(formData.componentName)
  ) {
    newErrors.componentName =
      "Component Name should not contain special character.";
  }
  const emails = [
    "senderEmailAddress",
    "partnerSupportEmail",
    "emailFrom",
    "supportEmail",
  ];
  const urls = [
    "termsAndConditionsLink",
    "siteDisclaimerLink",
    "privacyPolicyLink",
    "userAgreementLink",
    "disclaimerLink",
    "partnerLogoUrl",
    "partnerLoginUrl",
    "redirectUrl",
  ];
  const planForm = ["qtRate", "vendorQtRate", "subscriptionAmount", "erVendor"];
  emails.forEach((field) => {
    if (
      formData[field] &&
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData[field])
    ) {
      newErrors[field] = `Please enter a valid ${field
        .replace(/([A-Z])/g, " $1")
        .toLowerCase()} .`;
    }
  });

  urls.forEach((field) => {
    if (
      formData[field] &&
      !/^(https?:\/\/)?([\w\d-]+(\.[\w\d-]+)+)([\/\w\d#?&%=~.-]*)?$/.test(
        formData[field]
      )
    ) {
      newErrors[field] = `Please enter a valid URL for ${field
        .replace(/([A-Z])/g, " $1")
        .toLowerCase()}.`;
    }
  });
  planForm.forEach((field) => {
    if (formData[field] && !/^[0-9\b]+$/.test(formData[field])) {
      newErrors[
        field
      ] = `Special characters and alphabets are not allowed for ${field
        .replace(/([A-Z])/g, " $1")
        .toLowerCase()}.`;
    }
  });

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};

export const isValidUrl = (url) => {
  const pattern = new RegExp(
    "^(https?:\\/\\/)([\\w-]+\\.)+[\\w-]+([\\w.,@?^=%&:/~+#-]*[\\w@?^=%&/~+#-])?$"
  );
  return pattern.test(url);
};
export const validatePartnerForm = (formData, mode) => {
  const errors = {};
  const requiredFields = ["name", "code", "description"];

  const showLogoField =
    (formData.type || []).includes("whiteLabelled") ||
    (formData.type || []).includes("referral");
  const showHostField = (formData.type || []).includes("whiteLabelled");
  const showScopes = (formData.type || []).includes("api");

  requiredFields.forEach((field) => {
    if (!formData[field] || !formData[field].trim?.()) {
      errors[field] = `${
        field.charAt(0).toUpperCase() + field.slice(1)
      } is required`;
    }
  });

  if (showLogoField) {
    if (!formData.logo || !formData.logo.trim()) {
      errors.logo = "Logo URL is required.";
    }
    if (showHostField) {
      const host = String(formData.host || "").trim();
      const hostLower = host.toLowerCase();
      const isLocalhost = hostLower === "localhost";
      const isDomain = /^(?=.{1,253}$)(?!-)(?:[a-z0-9-]{1,63}\.)+[a-z0-9-]{2,63}$/.test(hostLower);

      if (!host) {
        errors.host = "Host URL is required.";
      } else if (/^https?:\/\//i.test(host) || host.includes("/") || host.includes("?") || host.includes("#") || host.includes("://")) {
        errors.host = "Host must be a domain only (e.g. example.com)";
      } else if (!isLocalhost && !isDomain) {
        errors.host = "Host must be a valid domain (e.g. example.com)";
      }
    }
  }
  if (showScopes) {
    if (!Array.isArray(formData.scopes) || formData.scopes.length === 0) {
      errors.scopes = "At least one scope must be selected.";
    }
  }

  if (!Array.isArray(formData.type) || formData.type.length === 0)
    errors.type = "At least one Partner Type must be selected.";
  if (formData.isWhiteLabel) {
    (formData.partnerTheme || []).forEach((theme, index) => {
      if (!theme.key || !theme.value) {
        errors[`theme_${index}`] =
          "Both key and value are required for theme entries when White Label is enabled";
      }
    });
  }

  return errors;
};

export const validatePlanForm = (formData, currentStep, mode) => {
  const errors = {};

  const fieldLabels = {
    code: "Plan Code",
    name: "Plan Name",
    currencyCd: "Currency",
    planSeq: "Plan Sequence",
    comment: "Comment",
  };

  const step1Required = ["code", "name", "currencyCd", "planSeq"];
  const step2Required = [];

  if (currentStep === 1) {
    step1Required.forEach((field) => {
      if (!formData[field] || (typeof formData[field] === 'string' && !formData[field].trim())) {
        errors[field] = `${fieldLabels[field] || field} is required.`;
      }
    });
  }

  if (currentStep === 2) {
    step2Required.forEach((field) => {
      if (!formData[field] || (typeof formData[field] === 'string' && !formData[field].trim())) {
        errors[field] = `${fieldLabels[field] || field} is required.`;
      }
    });
        if (mode === "update" && (!formData.comment || !formData.comment.trim())) {
      errors.comment = `${fieldLabels.comment} is required for updates.`;
    }
  }

  return errors;
};

export const validatePlanConfigArrayField = (arr, key) => {
  const isEmptyText = (val) => {
    if (typeof val !== "string") return true;
    // Remove HTML tags and whitespace
    const stripped = val
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/g, "")
      .trim();
    return !stripped;
  };

  const hasEmpty = (arr || []).some((item) => {
    if (key === "text") {
      return isEmptyText(item[key]);
    }
    return (
      !item[key] || (typeof item[key] === "string" && item[key].trim() === "")
    );
  });

  return hasEmpty;
};

export const validateCouponForm = (formData, mode) => {
  const errors = {};

  const fieldLabels = {
    code: "Coupon Code",
    startDt: "Start Date",
    expiryDt: "Expiry Date",
    partnerCode: "Partner",
    planId: "Plan",
    status: "Status",
    comment: "Comment",
  };

  const requiredFields = [
    "code",
    "startDt",
    "expiryDt",
    "partnerCode",
    "planId",
    "status",
  ];

  requiredFields.forEach((field) => {
    if (
      !formData[field] ||
      (typeof formData[field] === "string" && !formData[field].trim())
    ) {
      errors[field] = `${fieldLabels[field]} is required.`;
    }
  });

  if (mode === "update") {
    if (!formData.comment || !formData.comment.trim()) {
      errors.comment = `${fieldLabels.comment} is required for updates.`;
    }
  }

  return errors;
};
